import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import AuthModal from '../components/AuthModal';
import { useAuth } from '../hooks/useAuth';
import { getAdminAccessState } from '../utils/adminAuth';
import { BG } from '../constants/booking';

/**
 * Dedicated admin sign-in. No public registration.
 * On success with admin role, navigates to /admin.
 */
export default function AdminLogin() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading || !user) return;

    let cancelled = false;
    (async () => {
      try {
        const access = await getAdminAccessState(user);
        if (cancelled) return;
        if (access.hasAdminRole) {
          navigate('/admin', { replace: true });
        }
      } catch {
        /* stay on login */
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [user, loading, navigate]);

  const handleSuccess = async () => {
    navigate('/admin', { replace: true });
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: BG,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem 1rem',
      }}
    >
      <Helmet>
        <title>Admin Sign In | Digital Divot Golf</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <AuthModal
        isOpen
        loginOnly
        title="Admin Sign In"
        onClose={() => navigate('/', { replace: true })}
        onSuccess={handleSuccess}
      />
    </div>
  );
}
